<div>
    <span class="avatar">{{ short() }}</span>
    <span class="description">
        <span class="name">{{ user().name }}</span>
        <span class="role">{{ roleKey() | translate }}</span>
    </span>
    <button mat-icon-button (click)="logout.emit()">
        <mat-icon>logout</mat-icon>
    </button>
</div>
